import { createReducer, on } from '@ngrx/store';

import { AuthSessionState } from '../auth-state.model';
import { INITIAL_SESSION_STATE } from '../auth-state.constants';
import { AuthSessionActions } from './auth-session.actions';
import { AuthPasswordActions } from '../auth-password/auth-password.actions';
import { AuthSsoActions } from '../auth-sso/auth-sso.actions';

export const authSessionReducer = createReducer(
  INITIAL_SESSION_STATE,

  on(AuthSessionActions.login, (state, { rememberMe }) => ({
    ...state,
    loading: true,
    error: null,
    rememberMe,
  })),

  on(
    AuthSessionActions.loginSuccess,
    AuthSessionActions.hydrateSuccess,
    (state, { user }) => ({
      ...state,
      loading: false,
      user,
      failedLoginAttempts: 0,
      error: null,
    }),
  ),

  on(AuthSessionActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    failedLoginAttempts: state.failedLoginAttempts + 1,
    error,
  })),

  on(
    AuthPasswordActions.forgotPassword,
    AuthPasswordActions.resetPassword,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),

  on(
    AuthPasswordActions.forgotPasswordSuccess,
    AuthPasswordActions.resetPasswordSuccess,
    (state) => ({ ...state, loading: false, error: null }),
  ),

  on(
    AuthPasswordActions.forgotPasswordFailure,
    AuthPasswordActions.resetPasswordFailure,
    (state, { error }) => ({ ...state, loading: false, error }),
  ),

  on(AuthSessionActions.logout, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    AuthSessionActions.logoutSuccess,
    (): AuthSessionState => INITIAL_SESSION_STATE,
  ),

  on(AuthSessionActions.logoutFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(
    AuthSessionActions.hydrateFailure,
    (): AuthSessionState => INITIAL_SESSION_STATE,
  ),

  on(AuthSsoActions.exchangeCode, (state) => ({
    ...state,
    rememberMe: true,
  })),

  on(AuthSessionActions.rehydrate, (state, { user, rememberMe }) => ({
    ...state,
    user,
    rememberMe,
    loading: false,
    error: null,
  })),
);
